<template>
  <CommonLoading
		v-if="loading"
	/>
  <!-- MODAL -->
  <TransitionRoot as="template" :show="open">
    <Dialog class="relative z-50" @close="closeDialog">
      <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
        <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
      </TransitionChild>

      <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leave-from="opacity-100 translate-y-0 sm:scale-100" leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
            <DialogPanel class="relative transform overflow-hidden rounded-lg bg-white px-8 pb-8 pt-6 text-left shadow-xl transition-all sm:my-8 sm:w-full lg:max-w-4xl sm:p-6">
              <!-- Conteiner de título e botão de fechar -->
              <div class="flex justify-between items-start">
                <h2 class="text-xl font-bold leading-9 tracking-tight text-gray-900">Edição de Dados</h2>
                <button @click="closeDialog" type="button" class="text-gray-400 hover:text-gray-600 -mt-4">
                  <span class="sr-only">Fechar</span>
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>

              <!-- Formulário principal com flex -->
              <div class="mt-4">
                <form class="flex flex-wrap gap-4" @submit="sendData" method="POST">
                  <!-- Campo do Select para consultor_email -->
                  <div class="flex-1 min-w-[300px] sm:min-w-[300px] lg:w-1/2 mb-4">
                    <label for="consultor_email" class="block text-sm font-medium text-gray-900">Consultor</label>

                    <div class="mt-2 flex gap-2">
                      <select
                        v-model="data.consultor_email"
                        id="consultor_email"
                        name="consultor_email"
                        class="block w-full rounded-md border border-gray-300 py-2 px-3 shadow-sm focus:border-indigo-500 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                        :placeholder="placeHolderValues.consultor_email"
                      >
                        <option value="">Não se Aplica</option>
                        <option
                          v-for="consultor in consultores"
                          :key="consultor.email"
                          :value="consultor.email"
                        >
                          {{ consultor.name }}
                        </option>
                      </select>

                      <a
                        v-if="selectedConsultorAgendaLink"
                        :href="selectedConsultorAgendaLink"
                        target="_blank"
                        rel="noopener noreferrer"
                        class="inline-flex items-center justify-center rounded-md border border-gray-300 px-3 py-2 text-sm font-medium text-gray-900 shadow-sm hover:bg-gray-50 whitespace-nowrap"
                        title="Abrir agenda do consultor em nova aba"
                      >
                        Abrir agenda
                      </a>

                      <button
                        v-else
                        type="button"
                        disabled
                        class="inline-flex items-center justify-center rounded-md border border-gray-200 px-3 py-2 text-sm font-medium text-gray-400 bg-gray-100 cursor-not-allowed whitespace-nowrap"
                        title="Selecione um consultor com agenda cadastrada"
                      >
                        Abrir agenda
                      </button>
                    </div>
                  </div>

                  <!-- Campo tipo_visita -->
                  <div class="flex-1 min-w-[300px] sm:min-w-[300px] lg:w-1/2 mb-4">
                    <label for="tipo_visita" class="block text-sm font-medium text-gray-900">Tipo de Visita</label>
                    <select
                      v-model="data.tipo_visita"
                      id="tipo_visita"
                      name="tipo_visita"
                      required
                      class="mt-2 block w-full rounded-md border border-gray-300 py-2 px-3 shadow-sm focus:border-indigo-500 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                      :placeholder="placeHolderValues.tipo_visita"
                    >
                      <option value="">Selecione o tipo</option>
                      <option value="individual">Individual</option>
                      <option value="em_grupo">Em Grupo</option>
                      <option value="em_grupo_temporaria">Em Grupo Temporária</option>
                    </select>
                  </div>

                  <!-- Status Contato -->
                  <div class="flex-1 min-w-[300px] sm:min-w-[300px] lg:w-1/2 mb-4">
                    <label for="status_contato" class="block text-sm font-medium text-gray-900">Status do Contato</label>
                    <select 
                      name="status_contato" 
                      v-model="data.status_contato"
                      class="mt-2 block w-full rounded-md border border-gray-300 py-2 px-3 shadow-sm focus:border-indigo-500 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                    >
                      <option value="">Não se Aplica</option>
                      <option value="Contato via whats app">Contato via whats app</option>
                      <option value="Contato via telefone">Contato via telefone</option>
                      <option value="Sem contato">Sem contato</option>
                      <option value="Retornar">Retornar</option>
                    </select>
                  </div>

                  <!-- Telefone de Contato -->
                  <div class="flex-1 min-w-[300px] sm:min-w-[300px] lg:w-1/2 mb-4">
                    <label class="block text-sm font-medium text-gray-700 mb-1">Telefone de contato</label>
                    <select
                      v-model="telefoneSelecionado"
                      class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                    >
                      <option value="" disabled selected>Selecione um telefone</option>
                      <option
                        v-for="(telefone, index) in telefonesDisponiveis"
                        :key="index"
                        :value="telefone.numero"
                      >
                        {{ telefone.numero }}
                      </option>
                    </select>
                  </div>

                  <!-- Outros inputs do formulário -->
                  <div v-if="data.status_contato == 'Retornar'" class="flex-1 min-w-[300px] sm:min-w-[300px] lg:w-1/2">
                    <label for="data_retorno" class="block text-sm font-medium leading-6 text-gray-900">Data Para Retorno</label>
                    <input
                      v-model="data.data_retorno"
                      id="data_retorno"
                      name="data_retorno"
                      type="datetime-local"
                      class="mt-2 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    />
                  </div>

                  <!-- Data da Visita -->
                  <div class="flex-1 min-w-[300px] sm:min-w-[300px] lg:w-1/2">
                    <label for="data_visita" class="block text-sm font-medium leading-6 text-gray-900">Data da visita</label>
                    <input
                      v-model="data.data_visita"
                      id="data_visita"
                      name="data_visita"
                      type="datetime-local"
                      class="mt-2 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    />
                  </div>
                  
                  <!-- Status -->
                  <div class="flex-1 min-w-[300px] sm:min-w-[300px] lg:w-1/2 mb-4">
                    <label for="status" class="block text-sm font-medium text-gray-900">Status do Atendimento</label>
                    <select 
                      name="status" 
                      v-model="data.status"
                      class="mt-2 block w-full rounded-md border border-gray-300 py-2 px-3 shadow-sm focus:border-indigo-500 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                    > 
                      <option value="">Não se Aplica</option>
                      <option 
                        v-for="statusObj in statusOpcoes.filter(s => s.exibir_formulario)" 
                        :key="statusObj.status" 
                        :value="statusObj.status"
                      >
                        {{ statusObj.status }}
                      </option>
                    </select>
                  </div>

                  <!-- Integrar Google Agenda -->
                  <div class="flex-1 min-w-[300px] sm:min-w-[300px] lg:w-1/2 mb-4 flex items-center pt-6">
                    <div class="flex items-center">
                      <input
                        id="integrar_google_agenda"
                        name="integrar_google_agenda"
                        type="checkbox"
                        v-model="data.integrar_google_agenda"
                        class="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500 cursor-pointer"
                      />
                      <label for="integrar_google_agenda" class="ml-2 block text-sm text-gray-900 font-medium cursor-pointer">
                        Integrar com Google Agenda & Enviar E-mail
                      </label>
                    </div>
                  </div>

                  <!-- Observação -->
                  <div class="flex-1 min-w-[300px] sm:min-w-[300px] lg:w-1/2 mb-4">
                    <label for="observacao" class="block text-sm font-medium text-gray-900">Observação</label>
                    <textarea
                      name="observacao"
                      v-model="data.observacao"
                      rows="4"
                      class="mt-2 block w-full rounded-md border border-gray-300 py-2 px-3 shadow-sm focus:border-indigo-500 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                    ></textarea>
                  </div>

                  <!-- Endereço Visita -->
                  <div class="flex-1 min-w-[300px] sm:min-w-[300px] lg:w-1/2 mb-4"  
                  v-if="(placeHolderValues.segurado?.enderecos?.length || placeHolderValues.dependentes?.enderecos?.length)" 
                  >
                    <label for="enderecovisita" class="block text-sm font-medium text-gray-900">Endereços do Associado</label>
                    <select 
                      name="enderecovisita" 
                      v-model="data.endereco"
                      class="mt-2 block w-full rounded-md border border-gray-300 py-2 px-3 shadow-sm focus:border-indigo-500 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                    > 
                      <option value="">Não se Aplica</option>
                      <option v-for="(endereco, index) in placeHolderValues.segurado?.enderecos || placeHolderValues.dependentes?.enderecos" :key="'seg-' + index" 
                        :value="endereco.logradouro + ', ' + endereco.bairro + ', ' + endereco.cidade + '/' + endereco.estado + ' - CEP: ' + endereco.cep"> {{ endereco.logradouro }} - {{ endereco.bairro }}, {{ endereco.cidade }}/{{ endereco.estado }} - CEP: {{ endereco.cep }}</option>
                    </select>
                  </div>
                  <p 
                    v-else 
                    class="italic text-gray-500"
                  >
                    Nenhum endereço cadastrado.
                  </p>

                  <!-- Endereço -->
                  <div class="flex-1 min-w-[300px] sm:min-w-[300px] lg:w-1/2 mb-4">
                    <label for="endereco" class="block text-sm font-medium text-gray-900">Endereço</label>
                    <textarea
                      name="endereco"
                      v-model="data.endereco"
                      rows="4"
                      class="mt-2 block w-full rounded-md border border-gray-300 py-2 px-3 shadow-sm focus:border-indigo-500 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                    ></textarea>
                  </div>

                  <!-- Novo Campo de Anexos -->
                  <div class="flex-1 min-w-[300px] sm:min-w-[300px] lg:w-1/2 mb-4">
                    <label for="anexos" class="block text-sm font-medium text-gray-900">Anexos</label>
                    <input
                      type="file"
                      id="anexos"
                      name="anexos"
                      multiple
                      @change="handleFileUpload"
                      class="mt-2 block w-full text-sm text-gray-900 border border-gray-300 rounded-md cursor-pointer focus:outline-none focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                    />
                    <!-- Lista de arquivos selecionados -->
                    <div v-if="data.files && data.files.length > 0" class="mt-2 space-y-2">
                      <div v-for="(file, index) in data.files" :key="index" class="flex justify-between items-center bg-gray-100 p-2 rounded">
                        <span class="text-sm text-gray-700">{{ file.name }}</span>
                        <button
                          @click="removeFile(index)"
                          class="text-red-500 hover:text-red-700"
                        >
                          Remover
                        </button>
                      </div>
                    </div>
                  </div>

                  <!-- Empresas (mostrado apenas se for visita em grupo) -->
                  <div v-if="data.tipo_visita === 'em_grupo'" class="w-full mt-6">
                    <input
                      v-model="empresaBusca"
                      @input="buscarEmpresas"
                      type="text"
                      placeholder="Digite para buscar empresas..."
                      class="mt-1 block w-full rounded-md border-gray-300 shadow-sm sm:text-sm"
                    />
                    <ul
                      v-if="sugestoesEmpresas.length"
                      class="mt-2 border rounded p-2 max-h-40 overflow-y-auto"
                    >
                      <li
                        v-for="(empresa, index) in sugestoesEmpresas"
                        :key="index"
                        @click="vincularEmpresaLista(empresa)"
                        class="cursor-pointer hover:bg-gray-100 p-1 rounded"
                      >
                        {{ empresa.nome }}
                      </li>
                    </ul>

                    <!-- Divider Empresas -->
                    <div class="relative m-5">
                      <div class="absolute inset-0 flex items-center" aria-hidden="true">
                        <div class="w-full border-t border-gray-300" />
                      </div>
                      <div class="relative flex justify-start">
                        <span class="bg-white pr-3 text-base font-semibold text-gray-900">Empresas</span>
                      </div>
                    </div>
                  </div>
                  <!-- Badges -->
                  <div class="w-full mt-6">
                    <div class="relative">
                      <div class="absolute inset-0 flex items-center" aria-hidden="true">
                        <div class="w-full border-t border-gray-300" />
                      </div>
                      <div class="relative flex justify-center">
                        <button @click="badgeFormOpen = true" type="button" class="inline-flex items-center gap-x-1.5 rounded-lg bg-white px-3 py-1.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">
                          Adicionar Marcações
                        </button>
                      </div>
                    </div>
                    <BadgesView
                      :badges="placeHolderValues.segurado?.badges || []"
                      @delete-badge= "removeBadge"
                    />
                    <BadgesForm
                      :openBadge="badgeFormOpen"
                      @update-open-badge="badgeFormOpen = false"
                      @data-badge= "adicionarMarcacao"
                    />
                  </div>

                  <!-- Card das Visitas Agendadas -->
                  <div v-if="placeHolderValues.fichas_visita && placeHolderValues.fichas_visita.length > 0" class="w-full mt-6">
                    <div class="relative mb-5">
                      <div class="absolute inset-0 flex items-center" aria-hidden="true">
                        <div class="w-full border-t border-gray-300" />
                      </div>
                      <div class="relative flex justify-center">
                        <span class="bg-white px-2 font-semibold text-blue-700">Visitas Agendadas</span>
                      </div>
                    </div>
                    <div class="space-y-4">
                      <div v-for="(visita, index) in placeHolderValues.fichas_visita" :key="index" class="bg-gray-50 p-4 rounded-lg shadow-md">
                        <p><strong>Data da Visita:</strong> {{ visita.data_visita }}</p>
                         <p><strong>Contato feito por:</strong> {{ visita.agendador_email }}</p>
                        <p><strong>Status:</strong> {{ visita.status_visita }}</p>
                        <p><strong>Comentários do Consultor:</strong> {{ visita.comentarios_consultor || 'Nenhum comentário' }}</p>
                      </div>
                    </div>
                  </div>

                  <!-- Card dos Anexos -->
                  <div v-if="placeHolderValues.anexos && placeHolderValues.anexos.length > 0" class="w-full mt-6">
                    <div class="relative mb-5">
                      <div class="absolute inset-0 flex items-center" aria-hidden="true">
                        <div class="w-full border-t border-gray-300" />
                      </div>
                      <div class="relative flex justify-center">
                        <span class="bg-white px-2 font-semibold text-blue-700">Anexos</span>
                      </div>
                    </div>
                    <div class="space-y-4">
                      <div
                        v-for="(anexo, index) in placeHolderValues.anexos"
                        :key="index"
                        class="bg-gray-50 p-4 rounded-lg shadow-md flex items-center justify-between"
                      >
                        <p class="text-gray-800 truncate"><strong>Nome:</strong> {{ anexo.nome }}</p>
                        <a
                          :href="anexo.url"
                          target="_blank"
                          class="text-sm text-white bg-blue-600 hover:bg-blue-700 transition px-3 py-1 rounded-md"
                        >
                          Ver/Download
                        </a>
                      </div>
                    </div>
                  </div>
                  
                  <!-- Timeline do atendimento -->
                  <div class="w-full mt-6">
                      <div class="relative mb-5">
                        <div class="absolute inset-0 flex items-center" aria-hidden="true">
                          <div class="w-full border-t border-gray-300" />
                        </div>
                        <div class="relative flex justify-center">
                          <span class="bg-white px-2 font-semibold text-blue-700">Linha Temporal do Atendimento</span>
                        </div>
                      </div>
                      <div class="max-h-[400px] overflow-y-auto px-4 w-full mt-6">
                        <ol class="relative border-s border-gray-200 dark:border-gray-700">
                          <li
                            v-for="item in placeHolderValues.timeline"
                            :key="item.id"
                            class="mb-10 ms-4"
                          >
                            <div class="absolute w-3 h-3 bg-gray-200 rounded-full mt-1.5 -start-1.5 border border-white dark:border-gray-900 dark:bg-gray-700"></div>
                            <time class="mb-1 text-sm font-normal leading-none text-gray-400 dark:text-gray-500">
                              {{ new Date(item.created_at).toLocaleString() }}
                            </time>
                            <h3 class="text-lg font-semibold text-gray-900 dark:text-white">
                              {{ item.titulo }}
                            </h3>
                            <p class="mb-1 text-sm text-gray-500 dark:text-gray-400 italic">
                              Autor: {{ item.autor_email }}
                            </p>
                            <p class="text-base font-normal text-gray-700 dark:text-gray-300">
                              <!-- Se for observação, mostra o conteúdo; senão, a descrição padrão -->
                              {{ item.tipo === 'observacao adicionada' ? item.dados_extras?.conteudo : item.descricao }}
                            </p>
                        </li>
                      </ol>
                    </div>
                  </div>
                  
                  <!-- Card das Observações -->
                  <div v-if="placeHolderValues.observacoes && placeHolderValues.observacoes.length > 0" class="w-full mt-6">
                    <div class="relative mb-5">
                      <div class="absolute inset-0 flex items-center" aria-hidden="true">
                        <div class="w-full border-t border-gray-300" />
                      </div>
                      <div class="relative flex justify-center">
                        <span class="bg-white px-2 font-semibold text-blue-700">Observações</span>
                      </div>
                    </div>
                    <div class="space-y-4">
                      <div
                        v-for="(obs, index) in placeHolderValues.observacoes"
                        :key="index"
                        class="bg-gray-50 p-4 rounded-lg shadow-md"
                      > <p><strong>Autor:</strong> {{ obs.autor_email }}</p>
                        <p><strong>Telefone de Contato:</strong> {{ obs.telefone }}</p>
                        <p><strong>Descrição:</strong> {{ obs.descricao }}</p>
                        <p><strong>Data/Hora:</strong> {{ new Date(obs.created_at).toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'short' }) }}</p>
                      </div>
                    </div>
                  </div>
                  <!-- Card das Empresas Relacionadas com a visita -->
                  <div v-if="placeHolderValues.empresas && placeHolderValues.empresas.length > 0" class="w-full mt-6">
                    <div class="relative mb-5">
                      <div class="absolute inset-0 flex items-center" aria-hidden="true">
                        <div class="w-full border-t border-gray-300" />
                      </div>
                      <div class="relative flex justify-center">
                        <span class="bg-white px-2 font-semibold text-blue-700">Empresas Relacionadas Com Associado</span>
                      </div>
                    </div>

                    <div class="space-y-4">
                      <div
                        v-for="(empresa, index) in placeHolderValues.empresas"
                        :key="index"
                        class="bg-gray-50 p-4 rounded-lg shadow-md relative"
                      >
                        <!-- Mostrar botão SOMENTE se for visita individual E mais de uma empresa -->
                        <div
                          v-if="placeHolderValues.empresas.length > 1 || data.tipo_visita === 'individual'"
                          class="absolute top-2 right-2"
                        >
                          <button
                            @click="desvincularEmpresa(empresa.pivot.id)"
                            class="text-red-600 hover:text-red-800 text-sm font-medium transition"
                            title="Desvincular empresa"
                          >
                            Desvincular
                          </button>
                        </div>

                        <p><strong>Nome:</strong> {{ empresa.nome }}</p>
                        <p><strong>CNPJ:</strong> {{ empresa.cnpj }}</p>
                        <p><strong>Email:</strong> {{ empresa.email || 'Não informado' }}</p>
                      </div>
                    </div>
                  </div>

                  <!-- Card das Empresas Relacionadas -->
                  <div v-if="placeHolderValues.empresa" class="w-full mt-6">
                    <div class="relative mb-5">
                      <div class="absolute inset-0 flex items-center" aria-hidden="true">
                        <div class="w-full border-t border-gray-300" />
                      </div>
                      <div class="relative flex justify-center">
                        <span class="bg-white px-2 font-semibold text-blue-700">Empresa para qual rota está sendo feita</span>
                      </div>
                    </div>
                    <div class="space-y-4">
                      <div class="bg-gray-50 p-4 rounded-lg shadow-md">
                        <p><strong>Nome:</strong> {{ placeHolderValues.empresa.nome }}</p>
                        <p><strong>CNPJ:</strong> {{ placeHolderValues.empresa.cnpj }}</p>
                        <p><strong>Email:</strong> {{ placeHolderValues.empresa.email || 'Não informado' }}</p>
                      </div>
                    </div>
                  </div>

                  <!-- Dados do Segurado ou Dependente -->
                  <div v-if="placeHolderValues.segurado || placeHolderValues.dependentes" class="w-full mt-6">
                    <div class="relative mb-5">
                      <div class="absolute inset-0 flex items-center" aria-hidden="true">
                        <div class="w-full border-t border-gray-300" />
                      </div>
                      <div class="relative flex justify-center">
                        <span class="bg-white px-2 font-semibold text-blue-700"> Dados {{ placeHolderValues.segurado ? 'do Segurado' : 'do Dependente' }}</span>
                      </div>
                    </div>
                    <div class="mt-6 bg-gray-50 rounded-lg p-4 shadow-md">
                      <!-- Exibir Dados do Segurado -->
                      <div v-if="placeHolderValues.segurado" class="space-y-4 text-gray-700">
                        <p><strong>Nome:</strong> {{ placeHolderValues.segurado.nome }}</p>
                        <p><strong>CPF:</strong> {{ placeHolderValues.segurado.cpf }}</p>
                        <p><strong>Idade:</strong> {{ placeHolderValues.segurado.idade }}</p>
                        <p><strong>Email:</strong> {{ placeHolderValues.segurado.email || 'Não informado' }}</p>
                        <p><strong>Telefone:</strong> {{ placeHolderValues.segurado.telefone || 'Não informado' }}</p>
                        
                        <!-- Novo Campo de Mudança de Telefone Principal -->
                        <div class="mt-4 p-4 border-2 border-red-200 rounded-lg bg-red-50">
                          <label class="block text-sm font-bold text-red-700 mb-1">⚠️ ALTERAR NÚMERO DE TELEFONE PRINCIPAL (MUDANÇA CRÍTICA)</label>
                          <div class="flex gap-2">
                            <input 
                              v-model="novoTelefonePrincipal" 
                              type="text" 
                              placeholder="Digite o novo número aqui..."
                              class="block w-full rounded-md border-gray-300 shadow-sm focus:border-red-500 focus:ring-red-500 sm:text-sm text-gray-900"
                            />
                            <button 
                              @click="confirmarMudancaTelefone('segurado', placeHolderValues.segurado.id)"
                              type="button"
                              class="inline-flex items-center px-3 py-2 border border-transparent text-sm font-bold rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                            >
                              ALTERAR
                            </button>
                          </div>
                          <p class="mt-1 text-xs text-red-600 font-medium">* Esta ação mudará o telefone principal do segurado. O número antigo será guardado na lista de telefones extras.</p>
                        </div>

                        <!-- Telefones -->
                        <div>
                          <strong>Telefones:</strong>
                          <ul v-if="placeHolderValues.segurado.telefones?.length" class="list-disc ml-5 space-y-1">
                            <li v-for="(telefone, index) in placeHolderValues.segurado.telefones" :key="index">
                              {{ telefone.numero }}
                            </li>
                          </ul>
                          <p v-else class="italic text-gray-500">Nenhum telefone cadastrado.</p>
                        </div>

                        <!-- Endereços -->
                        <div>
                          <strong>Endereços:</strong>
                          <ul v-if="placeHolderValues.segurado.enderecos?.length" class="list-disc ml-5 space-y-1">
                            <li v-for="(endereco, index) in placeHolderValues.segurado.enderecos" :key="index">
                              {{ endereco.logradouro }} - {{ endereco.bairro }}, {{ endereco.cidade }}/{{ endereco.estado }} - CEP: {{ endereco.cep }}
                            </li>
                          </ul>
                          <p v-else class="italic text-gray-500">Nenhum endereço cadastrado.</p>
                        </div>
                      </div>
                      

                      <!-- Exibir Dados do Dependente -->
                      <div v-if="placeHolderValues.dependentes" class="space-y-4 text-gray-700">
                        <p><strong>Nome:</strong> {{ placeHolderValues.dependentes.nome || 'Não informado' }}</p>
                        <p><strong>CPF:</strong> {{ placeHolderValues.dependentes.cpf || 'Não informado' }}</p>
                        <p><strong>Email:</strong> {{ placeHolderValues.dependentes.email || 'Não informado' }}</p>
                         <p><strong>Telefone:</strong> {{ placeHolderValues.dependentes.telefone || 'Não informado' }}</p>

                         <!-- Novo Campo de Mudança de Telefone Principal Dependentes -->
                         <div class="mt-4 p-4 border-2 border-red-200 rounded-lg bg-red-50">
                          <label class="block text-sm font-bold text-red-700 mb-1">⚠️ ALTERAR NÚMERO DE TELEFONE PRINCIPAL DO DEPENDENTE</label>
                          <div class="flex gap-2">
                            <input 
                              v-model="novoTelefonePrincipal" 
                              type="text" 
                              placeholder="Digite o novo número aqui..."
                              class="block w-full rounded-md border-gray-300 shadow-sm focus:border-red-500 focus:ring-red-500 sm:text-sm text-gray-900"
                            />
                            <button 
                              @click="confirmarMudancaTelefone('dependente', placeHolderValues.dependentes.id)"
                              type="button"
                              class="inline-flex items-center px-3 py-2 border border-transparent text-sm font-bold rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                            >
                              ALTERAR
                            </button>
                          </div>
                          <p class="mt-1 text-xs text-red-600 font-medium">* Esta ação mudará o telefone principal do dependente. O número antigo será guardado na lista de telefones extras.</p>
                        </div>

                        <!-- Telefones -->
                        <div>
                          <strong>Telefones:</strong>
                          <ul v-if="placeHolderValues.dependentes.telefones?.length" class="list-disc ml-5 space-y-1">
                            <li v-for="(telefone, index) in placeHolderValues.dependentes.telefones" :key="index">
                              {{ telefone.numero }}
                            </li>
                          </ul>
                          <p v-else class="italic text-gray-500">Nenhum telefone cadastrado.</p>
                        </div>

                        <!-- Endereços -->
                        <div>
                          <strong>Endereços:</strong>
                          <ul v-if="placeHolderValues.dependentes.enderecos?.length" class="list-disc ml-5 space-y-1">
                            <li v-for="(endereco, index) in placeHolderValues.dependentes.enderecos" :key="index">
                              {{ endereco.logradouro }} - {{ endereco.bairro }}, {{ endereco.cidade }}/{{ endereco.estado }} - CEP: {{ endereco.cep }}
                            </li>
                          </ul>
                          <p v-else class="italic text-gray-500">Nenhum endereço cadastrado.</p>
                        </div>
                      </div>
                    </div>
                    <div class="w-full mt-6">
                     <div class="relative mb-5">
                        <div class="absolute inset-0 flex items-center" aria-hidden="true">
                          <div class="w-full border-t border-gray-300" />
                        </div>
                        <div class="relative flex justify-center">
                          <span class="bg-white px-2 font-semibold text-blue-700">Percurso do Consultor</span>
                        </div>
                      </div>
                    <RotaPercursoSimulado :locations="placeHolderValues.visita_atual"/>
                   </div>
                  </div>

                  <!-- Botão de envio -->
                  <div class="w-full">
                    <button type="submit" class="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500">Confirmar</button>
                  </div>
                </form>
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script>

import { Dialog, DialogPanel, TransitionChild, TransitionRoot } from '@headlessui/vue';
import RotaPercursoSimulado from '@/components/googleMapsApiComponents/GoogleMapsRouteComponent.vue';
import BadgesView from '@/components/generalcomponents/BadgesView.vue';
import BadgesForm from '@/components/generalcomponents/BadgesForm.vue';
import EmpresasRepository from '@/services/EmpresasRepository.vue';
import debounce from 'lodash/debounce';
import { handleUnauthorized } from '@/services/AuthSer/authServiceFunction';
import CommonLoading from '@/components/generalcomponents/CommonLoading.vue';
import ListaDeAgendamentosRepository from '@/services/ListaDeAgendamentosRepository.vue';
import Swal from "sweetalert2";

export default {
  name: 'ListaDeAgendamentosForm',
  emits:['update-open', 'segurado-badge', 'editing-data', 'remove-badge', 'empresa-lista','desvincular-empresa'],
  props: {
    open: {
      type: Boolean,
      required: true
    },
    placeHolderValues: {
      type: Object,
      required: true
    },
    consultores: {
      type: Array,
      required: true
    },
    statusOpcoes: {
      type: Array,
      default: () => []
    }
  },
   created() {
    this.buscarEmpresas = debounce((...args) => {
      this._buscarEmpresas(...args);
    }, 400); // 400ms de espera
  },
  data() {
    return {
      data: {
        files: [], // Novo campo pra armazenar os arquivos
      },
      telefoneSelecionado: '',
      novoTelefonePrincipal: '',
      badgeFormOpen: false,
      originalData: null,
      loading: false,
      empresaBusca: '',
      sugestoesEmpresas: [],
      onlineUser: JSON.parse(window.localStorage.getItem("myUser")),
    };
  },
  watch: {
    open(newVal) {
      if (newVal) {
        this.loadData();
      }
    }
  },
  methods: {

    async _buscarEmpresas() {
      if (!this.empresaBusca || this.empresaBusca.length < 4) {
        this.sugestoesEmpresas = [];
        return;
      }
      this.getEmpresas(this.empresaBusca);
    },

    async getEmpresas(query) {
      this.loading = true;
			const empresasRepo = new EmpresasRepository();
			try {
				const response = await empresasRepo.getEmpresaQuery(this.onlineUser.token, query);
				if (response?.status === 200) {
          this.loading = false;
          this.sugestoesEmpresas = response.data;
				} else {
          this.loading = false;
					this.error = response?.message;
				}
			} catch (error) {
				this.loading = false;
				handleUnauthorized(error);
			}
		},

    sendData(e) {
      e.preventDefault();
      this.$emit('editing-data', {
        ...this.data,
        telefone_contato: this.telefoneSelecionado || null,
        files: this.data.files.map(file => ({
          name: file.name,
          type: file.type,
          content: file.content
        }))
      }, this.placeHolderValues.id);
    },

    handleFileUpload(event) {
      const files = Array.from(event.target.files);

      files.forEach((file) => {
        const reader = new FileReader();

        reader.onload = () => {
          this.data.files.push({
            name: file.name,
            type: file.type,
            content: reader.result.split(',')[1], // Remove o prefixo "data:<mime-type>;base64,"
          });
        };

        reader.readAsDataURL(file);
      });
    },

    async vincularEmpresaLista(empresa){
      const id = this.placeHolderValues.id;
      console.log(id)
      const payload = {
        empresa_id: empresa.id
      }
			this.loading = true; 
			const listaRepo = new ListaDeAgendamentosRepository();
			try {
				const response = await listaRepo.vincularEmpresaLista(id,this.onlineUser.token,payload);
				if (response?.status === 200) {
					this.mostrarAlerta();
          this.$emit('empresa-lista', id);
					this.loading = false; 
				} else {
					this.error = response?.message;
					this.mostrarAlertaErro(this.error);
					this.loading = false;
				}
			} catch (error) {
				handleUnauthorized(error);
				this.loading = false; 
			}	
		},

    removeFile(index) {
      this.data.files.splice(index, 1);
    },

    closeDialog() {
      this.data = { files: [], integrar_google_agenda: false }; // Reseta incluindo os arquivos  
      this.$emit('update-open', false);
    },

    loadData() {
      this.originalData = JSON.parse(JSON.stringify(this.placeHolderValues)); // Clona os dados originais
      this.data = { ...this.originalData, files: [], integrar_google_agenda: false }; // Preenche com dados e inicializa files
    },

    adicionarMarcacao(badge){
      badge.tipo = this.data.socio;
      badge.id = this.data.segurado_id;
      this.$emit('segurado-badge', badge);
    },

    removeBadge(id){
      this.$emit('remove-badge', id);
    },

    desvincularEmpresa(id){
      this.$emit('desvincular-empresa', id);
    },

    mostrarAlerta() {
			Swal.fire({
				icon: 'success',
				title: 'Sucesso!',
				text: 'A operação foi concluída com sucesso.',
				confirmButtonColor: '#3085d6',
			});
		},

		mostrarAlertaErro(message) {
			Swal.fire({
				icon: 'error',
				title: 'Erro!',
				text: message,
				confirmButtonColor: '#3085d6', 
			});
		},

    async confirmarMudancaTelefone(tipo, id) {
      if (!this.novoTelefonePrincipal) {
        return this.mostrarAlertaErro("Por favor, digite o novo número de telefone.");
      }

      const result = await Swal.fire({
        title: '⚠️ MUDANÇA CRÍTICA!',
        text: `Você tem certeza que deseja alterar o telefone principal? Esta ação é irreversível e mudará o contato principal do ${tipo}.`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'SIM, ALTERAR AGORA!',
        cancelButtonText: 'Cancelar'
      });

      if (result.isConfirmed) {
        this.loading = true;
        const repo = new ListaDeAgendamentosRepository();
        try {
          const response = await repo.mudarTelefonePrincipal(this.onlineUser.token, {
            tipo,
            id,
            novo_numero: this.novoTelefonePrincipal,
            auth: { email: this.onlineUser.email }
          });

          if (response.status === 200) {
            this.mostrarAlerta();
            this.novoTelefonePrincipal = '';
            // Recarrega os dados do agendamento para refletir a mudança
            this.$emit('empresa-lista', this.placeHolderValues.id); 
          } else {
            this.mostrarAlertaErro(response.data.message || "Erro ao atualizar telefone.");
          }
        } catch (error) {
          console.error(error);
          this.mostrarAlertaErro("Erro ao processar a solicitação.");
        } finally {
          this.loading = false;
        }
      }
    },
    
  },
  computed: {
    telefonesDisponiveis() {
      const dependente = this.placeHolderValues?.dependentes;
      const segurado = this.placeHolderValues?.segurado;

      let telefones = [];

      // Telefones do dependente
      if (dependente) {
        // Telefones extras (array)
        if (Array.isArray(dependente.telefones)) {
          telefones = telefones.concat(dependente.telefones);
        }

        // Telefone principal do dependente
        if (dependente.telefone) {
          telefones.push({
            id: `telefone_principal_dependente_${dependente.id || 'dep'}`,
            numero: dependente.telefone,
            origem: 'principal_dependente'
          });
        }
      }

      // Telefones do segurado
      if (segurado) {
        // Telefones extras (array)
        if (Array.isArray(segurado.telefones)) {
          telefones = telefones.concat(segurado.telefones);
        }

        // Telefone principal do segurado
        if (segurado.telefone) {
          telefones.push({
            id: `telefone_principal_segurado_${segurado.id || 'seg'}`,
            numero: segurado.telefone,
            origem: 'principal_segurado'
          });
        }
      }

      return telefones;
    },
    selectedConsultorAgendaLink() {
      if (!this.data.consultor_email) return null;

      const c = this.consultores.find(x => x.email === this.data.consultor_email);
      return c?.agenda_link || null;
    },
  },
  components: {
    Dialog,
    DialogPanel,
    TransitionChild,
    TransitionRoot,
    RotaPercursoSimulado,
    BadgesView,
    BadgesForm,
    CommonLoading
  }
};
</script>